export const isValidUKPostcode = (postcode) => {
  if (!postcode) return false;

  // UK postcode regex pattern
  const postcodeRegex = /^[A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2}$/i;
  return postcodeRegex.test(postcode.trim());
};
export const formatUKPostcode = (postcode) => {
  if (!postcode) return '';

  // Remove any existing spaces and convert to uppercase
  const cleanPostcode = postcode.replace(/\s/g, '').toUpperCase();

  // UK postcodes always have the format: area + district + space + sector + unit
  // The outward code (area + district) can be 2-4 characters
  // The inward code (sector + unit) is always 3 characters (number + 2 letters)

  // For all valid UK postcodes, we want to insert a space before the last 3 characters
  // This works for all formats: AA9A 9AA, A9A 9AA, A9 9AA, A99 9AA, AA9 9AA, AA99 9AA
  const formatted = cleanPostcode.replace(/(^[A-Z]{1,2}[0-9][A-Z0-9]?)([0-9][A-Z]{2}$)/i, '$1 $2');

  console.log(`Formatted postcode: ${cleanPostcode} → ${formatted}`);
  return formatted;
};
